import { assertNever } from 'owa-assert';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { AddToCalendarText } from 'owa-locstrings/lib/strings/addtocalendartext.locstring.json';
import { downloadText } from 'owa-locstrings/lib/strings/downloadtext.locstring.json';
import {
    editAndReplyText,
    openNewTabText,
    saveToCloudText,
    openAndEditText,
    viewInOneDriveText,
} from './AttachmentSurfaceActionButton.locstring.json';
import { SurfaceAction } from '../../types/SurfaceAction';
import { isOfficeFile } from '../../utils/isOfficeFile';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';

export function getIconName(action: SurfaceAction, attachmentId: AttachmentId): ControlIcons {
    switch (action) {
        case SurfaceAction.addToCalendar:
            return ControlIcons.AddEvent;
        case SurfaceAction.download:
            return ControlIcons.Download;
        case SurfaceAction.saveToCloud:
            return ControlIcons.CloudUpload;
        case SurfaceAction.openNewTabAndSaveToCloud:
            return ControlIcons.Edit;
        case SurfaceAction.editAndReply:
            return ControlIcons.PencilReply;
        case SurfaceAction.openAndEdit:
            return isOfficeFile(attachmentId) ? ControlIcons.CloudEdit : ControlIcons.Cloud;
        default:
            return assertNever(action);
    }
}

export function getIconTitle(action: SurfaceAction, attachmentId: AttachmentId): string {
    switch (action) {
        case SurfaceAction.addToCalendar:
            return loc(AddToCalendarText);
        case SurfaceAction.download:
            return loc(downloadText);
        case SurfaceAction.saveToCloud:
            return loc(saveToCloudText);
        case SurfaceAction.openNewTabAndSaveToCloud:
            return loc(openNewTabText);
        case SurfaceAction.editAndReply:
            return loc(editAndReplyText);
        case SurfaceAction.openAndEdit:
            return isOfficeFile(attachmentId) ? loc(openAndEditText) : loc(viewInOneDriveText);
        default:
            return assertNever(action);
    }
}
